import { render, staticRenderFns } from "./Churchs.vue?vue&type=template&id=71047a21&scoped=true&"
import script from "./Churchs.vue?vue&type=script&lang=js&"
export * from "./Churchs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71047a21",
  null
  
)

export default component.exports